import { render, staticRenderFns } from "./engagement-content.vue?vue&type=template&id=8a48fb90&scoped=true&"
import script from "./engagement-content.vue?vue&type=script&lang=js&"
export * from "./engagement-content.vue?vue&type=script&lang=js&"
import style0 from "./engagement-content.vue?vue&type=style&index=0&id=8a48fb90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a48fb90",
  null
  
)

component.options.__file = "engagement-content.vue"
export default component.exports